var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-layout"},[_c('header',{staticClass:"layout-header"},[_vm._t("header")],2),_c('main',{staticClass:"layout-content"},[_vm._t("default")],2),_c('footer',{staticClass:"layout-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }